import { useLogin } from 'hooks/useLogin';
import { useCheckCrops } from 'hooks/useCheckCrops';

export function useLoginForm() {

  const { isLoading: isLoggingIn, data: loginData, mutate: login, isSuccess: hasLoggedIn, isError: failedLoggingIn, error: loginError } = useLogin();
  const {
    isLoading: isCheckingCrops,
    data: checkCropsData,
    mutate: checkCrops,
    isSuccess: hasCheckedCrops,
    isError: failedCheckingCrops,
    error: checkCropsError,
  } = useCheckCrops();


  return {
    isLoggingIn,
    login,
    loginData,
    hasLoggedIn,
    failedLoggingIn,
    loginError,
    isCheckingCrops,
    checkCropsData,
    checkCrops,
    hasCheckedCrops,
    failedCheckingCrops,
    checkCropsError,
  }

}
